import React from "react";

const TextArea = ({
  name,
  id,
  type,
  placeholder,
  className,
  onChange,
  onBlur,
  validation,
  validationMsg,
  onkeypress,
  value,
  maxlength,
  style,
  dataQuestId,
  row,
  keypress
}) => {
  return (
    <>
      <textarea
        name={name}
        id={id}
        data-quest-id={dataQuestId}
        placeholder={placeholder}
        className={className}
        type={type}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={keypress}
        ref={validation}
        defaultValue={value}
        maxLength={maxlength}
        rows={row}
        style={style}
      ></textarea>
      {validationMsg && (
        <>
          <span className="error_msg">{validationMsg}</span>
        </>
      )}
    </>
  );
};
export default TextArea;